import { useCallback, useState } from 'react';
import { ADMIN_ROUTES } from 'constants/routes';
import { useNavigate, useParams } from 'react-router-dom';
import { PurchaseRequestStatusType } from 'models/PurchaseRequest';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { useItemTagsQuery, usePurchaseRequestByIdQuery, usePurchaseRequestStatusChangeMutation } from 'api';
import { TypeOfEntityType } from 'models/ComunicationHub';

export const useDetails = () => {
  const [assignmentModalState, setAssignmentModalState] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const { handleError, handleSuccess } = useNotificationMessages();
  const { data: itemTags = [] } = useItemTagsQuery();
  const { data = {} } = usePurchaseRequestByIdQuery({ id });
  const { purchaseRequest = {}, assignments = {} } = data;
  const isFinalStatus = purchaseRequest?.isFinalStatus;

  const [changeStatus] = usePurchaseRequestStatusChangeMutation();

  const onAssignmentCancel = useCallback(() => setAssignmentModalState(false), []);
  const onAssignmentOpen = useCallback(() => setAssignmentModalState(true), []);
  const onRedirectToEntity = useCallback(
    (id: string, entityName: TypeOfEntityType) => {
      switch (entityName) {
        case 'BRAND':
          navigate(`${ADMIN_ROUTES.brand.view}/${id}/management`);
          return;
        case 'CLIENT':
          navigate(`${ADMIN_ROUTES.client}/${id}/general`);
          return;
        case 'LEAD':
          navigate(`${ADMIN_ROUTES.leads.view}/${id}/general`);
          return;
        case 'DEAL':
          navigate(`${ADMIN_ROUTES.deals.view}/${id}/purchase-request`);
          return;
        default:
          return;
      }
    },
    [navigate]
  );

  const handleStatusChange = useCallback(
    async (status: PurchaseRequestStatusType) => {
      try {
        const { data, error }: any = await changeStatus({ purchaseRequestId: id, status });
        if (data?.success) {
          handleSuccess('The purchase request status was successfully changed.');
        } else {
          handleError(error);
        }
      } catch (err) {
        console.log(err, 'error');
      }
    },
    [handleSuccess, changeStatus, id, handleError]
  );
  return {
    assignments,
    purchaseRequest,
    itemTags,
    onRedirectToEntity,
    handleStatusChange,
    assignmentModalState,
    onAssignmentCancel,
    onAssignmentOpen,
    isFinalStatus,
  };
};
